export const getScheduleFlowId = state => state.scheduleFlows.scheduleFlow.id;
export const getScheduleFlowEmail = state => state.scheduleFlows.scheduleFlow.email;
export const getScheduleFlowData = state => state.scheduleFlows.scheduleFlow;
export const scheduleFlowIsFetching = state => state.scheduleFlows.loading;
